import { useEffect, useState } from 'react'
import { useStore } from '@/stores'
import { enterPipAnchor, exitPipAnchor, isPipSupported } from '@/lib/pipAnchor'
import { useToast } from '@/components/providers/ToastProvider'

export function PipToggle(): JSX.Element | null {
  const isRecording = useStore((state) => state.isRecording)
  const [pinned, setPinned] = useState(false)
  const [supported] = useState(() => isPipSupported())
  const { showToast } = useToast()

  useEffect(() => {
    if (!isRecording && pinned) {
      void exitPipAnchor()
      setPinned(false)
    }
  }, [isRecording, pinned])

  if (!isRecording || !supported) return null

  const handleClick = async () => {
    if (pinned) {
      await exitPipAnchor()
      setPinned(false)
      return
    }
    try {
      await enterPipAnchor(() => setPinned(false))
      setPinned(true)
    } catch (err) {
      console.warn('[pip] request failed', err)
      showToast('Could not pin recording window.', 'error', 4000)
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-xs rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-white/90 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-neon-cyan"
      aria-pressed={pinned}
      aria-label={pinned ? 'Unpin recording window' : 'Pin recording window to keep capturing when you switch apps'}
    >
      {pinned ? 'Unpin window' : 'Keep recording in background'}
    </button>
  )
}
